import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-mcqquestion-dialog',
  templateUrl: './add-mcqquestion-dialog.component.html',
  styleUrls: ['./add-mcqquestion-dialog.component.scss']
})
export class AddMcqquestionDialogComponent implements OnInit {
  colors = [
    '#9E9E9E',
    '#673AB7',
    '#FF9800',

    '#FF5722',
    '#4285F4',

    '#4CAF50',

    '#009688',
    '#607D8B',
    '#00BCD4'
  ];
  constructor() { }

  ngOnInit() {
  }

}
